import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconProductGridComponent } from "./med-icon-product-grid.component";

@NgModule({
  declarations: [
    MedIconProductGridComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconProductGridComponent,
  ],
})
export class MedIconProductGridModule { }
